var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "h-full" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-row gap-4 items-center py-3 mb-2 justify-between",
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-row gap-4 items-center" },
            [
              _c("FormGroup", {
                attrs: {
                  title: "",
                  type: "search",
                  iconStyle: "customIcon",
                  inputClass: "customFormInput fullwidthform NotesWidth",
                  placeholder: "Search for Manager Name",
                  debounceTime: 500,
                },
                model: {
                  value: _vm.searchName,
                  callback: function ($$v) {
                    _vm.searchName = $$v
                  },
                  expression: "searchName",
                },
              }),
              _c("FormGroup", {
                attrs: {
                  title: "",
                  type: "search",
                  iconStyle: "customIcon",
                  inputClass: "customFormInput fullwidthform",
                  placeholder: "Search by Address",
                  debounceTime: 500,
                },
                model: {
                  value: _vm.searchLocation,
                  callback: function ($$v) {
                    _vm.searchLocation = $$v
                  },
                  expression: "searchLocation",
                },
              }),
              _c(
                "FormGroup",
                { staticClass: "mb-0" },
                [
                  _c("FormDatepicker", {
                    attrs: {
                      iconStyle: "customIcon",
                      inputClass: "customFormInput",
                      calendarClass:
                        "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                      isCalenderIcon: true,
                      customInputClass:
                        "rounded-lg text-storm-gray text-sm h-1",
                      label: "",
                      placeholder: "Date",
                    },
                    model: {
                      value: _vm.searchDate,
                      callback: function ($$v) {
                        _vm.searchDate = $$v
                      },
                      expression: "searchDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("UiButtonMessage", {
                attrs: {
                  buttonClass: "customAdd",
                  buttonText: "Reset",
                  textClass: "customText customOnlyText",
                },
                on: { click: _vm.handleResetSearch },
              }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "text-gray-600 text-sm mb-3 mt-0" }, [
        _vm._v("Total : "),
        _c("span", { staticClass: "font-bold text-black" }, [
          _vm._v(_vm._s(_vm.raw_ManagerProjects?.totalContractors || 0)),
        ]),
      ]),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.raw_ManagerProjects.loading,
            hasData: _vm.managerProjects.length > 0,
          },
        },
        [
          _c("Scheduler", {
            attrs: {
              resources: _vm.resources,
              events: _vm.events,
              listeners: _vm.listeners,
              schedularType: _vm.schedularType,
            },
          }),
        ],
        1
      ),
      _vm.modalShown && _vm.modalType === "activity"
        ? _c("ActivityFormModal", {
            attrs: {
              project: _vm.projectInfoForModal,
              projectActivity: _vm.activityInfoForModal,
              currentUserRole: _vm.currentUser.role,
              contractorId: _vm.contractorIdForModal,
              companyId: _vm.companyId,
              currentUserId: _vm.currentUser.id,
              show_cancel_draft_actions: false,
            },
            on: {
              activityAdded: _vm.handleCollectionUpdated,
              activityUpdated: _vm.refetchCollection,
              close: _vm.handleCloseModal,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "activity_actions_slot",
                  fn: function () {
                    return [
                      _c("p", { staticClass: "text-sm flex items-center" }, [
                        _c(
                          "span",
                          { staticClass: "text-gray-600" },
                          [_c("ScheduleInfoIcon", { staticClass: "mr-1 w-4" })],
                          1
                        ),
                        _vm._v(
                          " Tasks created on the calendar are final and cannot be saved as draft. "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2451429914
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }